import React from "react";

function TargetPopulations({ populations, selected, onChange }) {
  if (!populations || populations.length === 0) return null;

  function handleToggle(id) {
    const newSelected = selected.includes(id)
      ? selected.filter((s) => s !== id)
      : [...selected, id];
    onChange(newSelected);
  }

  return (
    <div className="target-populations">
      <div className="target-populations-outer">
        <div className="filter-section-heading">
          <span className="label-no-transform">Target Population</span>
          <span className="small-text">Select all that apply</span>
        </div>
        <div className="targeted-populations-search">
          <div className="target-populations-container">
            {populations.map((tp) => {
              const isActive = selected.includes(tp.id);
              return (
                <span key={tp.id} className={`target-population${isActive ? " active" : ""}`}>
                  <button
                    className="btn btn-tag target-population-item"
                    type="button"
                    onClick={() => handleToggle(tp.id)}
                  >
                    <span className="tp-add" aria-hidden="true">{isActive ? null : "+"}</span>
                    <span>
                      {tp.name}
                    </span>
                    {isActive && <span className="tp-close" aria-hidden="true">&times;</span>}
                  </button>
                </span>
              );
            })}
          </div>
        </div>
      </div>
    </div>
  );
}

export default TargetPopulations;
